<template>
  <v-autocomplete
    v-model="selectedSolutions"
    :items="solutions"
    :loading="loading"
    clearable
    label="Soluções"
    placeholder="Selecione as soluções"
    item-text="nome"
    item-value="solucaoId"
    multiple
    :disabled="!grupoSolucaoId"
    :hint="!grupoSolucaoId ? 'Selecione um grupo de solução primeiro' : ''"
    persistent-hint
    @input="onSolutionChange"
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon :color="selectedSolutions.length > 0 ? 'indigo darken-4' : ''">
          {{ iconMultiple }}
        </v-icon>
      </div>
      <div>Todas</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <div v-if="index < maxDisplay">
        <span>{{ item.nome }}</span>
      </div>
      <span v-if="index === maxDisplay" class="grey--text caption">
        (+{{ selectedSolutions.length - maxDisplay }} soluções)
      </span>
    </template>

    <template slot="no-data">
      <span v-if="!grupoSolucaoId">Selecione um grupo de solução primeiro</span>
      <span v-else>Nenhuma solução retornada</span>
    </template>
  </v-autocomplete>
</template>

<script>
import { solutionAPI } from "./SolutionAPI";

export default {
  name: "AppSolutionCombobox",
  props: {
    grupoSolucaoId: {
      type: [Number, String],
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      solutions: [],
      loading: false,
      selectedSolutions: this.value,
      maxDisplay: 1,
    };
  },
  computed: {
    likesAll() {
      return this.selectedSolutions.length === this.solutions.length;
    },
    likesSome() {
      return this.selectedSolutions.length > 0 && !this.likesAll;
    },
    iconMultiple() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    grupoSolucaoId: {
      handler(newVal) {
        if (newVal) {
          this.loadSolutions();
        } else {
          this.solutions = [];
          this.selectedSolutions = [];
        }
      },
      immediate: true,
    },
    value(newVal) {
      this.selectedSolutions = newVal;
    },
  },
  methods: {
    async loadSolutions() {
      if (!this.grupoSolucaoId) return;

      this.loading = true;
      try {
        const response = await solutionAPI.getOnlyGrupo(this.grupoSolucaoId);
        this.solutions = response.data || [];
      } catch (error) {
        console.error("Erro ao carregar soluções:", error);
        this.$notification.error("Erro ao carregar soluções");
        this.solutions = [];
      } finally {
        this.loading = false;
      }
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.selectedSolutions = [];
        } else {
          this.selectedSolutions = this.solutions.map((s) => s.solucaoId);
        }
        this.onSolutionChange();
      });
    },
    onSolutionChange() {
      this.$emit("input", this.selectedSolutions);
      this.$emit("changeSolutions", this.selectedSolutions);
    },
  },
};
</script>
